"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BurgerMenuIcon = require("./BurgerMenuIcon");
Object.keys(_BurgerMenuIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BurgerMenuIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BurgerMenuIcon[key];
    }
  });
});
